import { useEffect, createContext, useContext } from "@wordpress/element";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { selectCartLineItems } from "store/vino/cartSlice";
import { getCheckout, setSubtotalPrice } from "store/vino/checkoutSlice";
import { calculateSubtotal } from "utils";
import { settings } from "settings";

export const CheckoutContext = createContext({});
export const useCheckoutContext = () => useContext(CheckoutContext);

export const CheckoutContextProvider = ({ children }) => {
	const dispatch = useDispatch();
	const cartLineItems = useSelector(selectCartLineItems);
	const { id: cartId, checkoutId } = useSelector(({ vino }) => vino.cart);
	const contextValue = {
		cartId,
		cartLineItems,
		checkoutId,
	};

	useEffect(() => {
		if (checkoutId) {
			dispatch(getCheckout(checkoutId));
		}
	}, [dispatch, checkoutId]);

	useEffect(() => {
		if (cartLineItems.length) {
			dispatch(setSubtotalPrice(calculateSubtotal(cartLineItems)));
		}
	}, [cartLineItems]);

	return (
		<CheckoutContext.Provider value={contextValue}>
			{children}
		</CheckoutContext.Provider>
	);
};

CheckoutContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
